// extracted by mini-css-extract-plugin
export var localeSelector = "_42-0";